import { useEffect, useState } from 'react';

import { PROPOSAL_DOCUMENT_DIMENSIONS } from './use-simulation-document-export';

export const usePrintMode = (): boolean => {
  const [isPrintMode, setIsPrintMode] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return new URLSearchParams(window.location.search).has('print');
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const hasPrintParam = searchParams.has('print');
    setIsPrintMode(hasPrintParam);

    if (hasPrintParam) {
      const w = `${PROPOSAL_DOCUMENT_DIMENSIONS.w}px`;
      const h = `${PROPOSAL_DOCUMENT_DIMENSIONS.h}px`;

      document.documentElement.style.width = w;
      document.documentElement.style.minWidth = w;
      document.documentElement.style.overflow = 'visible';

      document.body.style.width = w;
      document.body.style.minWidth = w;
      document.body.style.overflow = 'visible';
      document.body.style.margin = '0';
      document.body.style.padding = '0';

      if (!document.getElementById('clarke-print-page-size')) {
        const style = document.createElement('style');
        style.id = 'clarke-print-page-size';
        style.textContent = `@page { size: ${w} ${h}; margin: 0; }`;
        document.head.appendChild(style);
      }
    }
  }, []);

  return isPrintMode;
};
